
export const formattingMoney = (money) => {
    return Number(money.toFixed(4)).toLocaleString()
}
export const formattingPercent = (Percent) => {
    return Number(Percent.toFixed(4)).toLocaleString()
}